// Left-rail scenario tree. Reflects SECTIONS (sections.js). Per-node
// badges show the count of parameters that have been filled in (source,
// confidence) for that section.
import { SECTIONS } from "@/components/workbench/sections";

function sectionCount(scenario, sectionId) {
    const bucket = scenario?.parameters?.[sectionId];
    if (!bucket) return 0;
    return Object.keys(bucket).length;
}

export default function WorkbenchTree({ scenario, activeSection, onSelect }) {
    return (
        <nav
            aria-label="Scenario sections"
            className="h-full overflow-y-auto py-2"
            data-testid="workbench-tree"
        >
            <div className="px-3 pt-1 pb-3 text-[10px] uppercase tracking-[0.18em] text-ux-text-3 font-mono">
                Scenario tree
            </div>
            <ul className="flex flex-col gap-1 px-2">
                {SECTIONS.map((s) => {
                    const Icon = s.icon;
                    const count = sectionCount(scenario, s.id);
                    const active = activeSection === s.id;
                    return (
                        <li key={s.id}>
                            <button
                                type="button"
                                onClick={() => onSelect(s.id)}
                                className={[
                                    "w-full text-left flex items-center gap-2 px-2.5 py-2 rounded-md text-[13px] transition-colors",
                                    active
                                        ? "bg-ux-bg-2 text-ux-text-1"
                                        : "text-ux-text-2 hover:text-ux-text-1 hover:bg-ux-bg-2",
                                ].join(" ")}
                                aria-current={active ? "true" : undefined}
                                data-testid={`workbench-tree-item-${s.id}`}
                            >
                                <Icon
                                    className={
                                        active
                                            ? "w-4 h-4 text-ux-accent shrink-0"
                                            : "w-4 h-4 text-ux-text-3 shrink-0"
                                    }
                                    aria-hidden="true"
                                />
                                <span className="flex-1 min-w-0 truncate">{s.label}</span>
                                <span
                                    className={[
                                        "inline-flex items-center justify-center min-w-[22px] h-5 rounded-full text-[10px] font-mono tabular-nums px-1.5",
                                        count > 0
                                            ? "bg-ux-accent/10 text-ux-accent"
                                            : "bg-ux-bg-3 text-ux-text-3",
                                    ].join(" ")}
                                    aria-label={`${count} parameters configured`}
                                    data-testid={`workbench-tree-count-${s.id}`}
                                >
                                    {count}
                                </span>
                            </button>
                        </li>
                    );
                })}
            </ul>
            <p
                className="mt-4 px-3 text-[11px] leading-relaxed text-ux-text-3 border-t border-ux-border-1 pt-3"
                data-testid="workbench-tree-hint"
            >
                Sections fill in as Modules 2-7 land. Module 1 renders
                the skeleton so validation + provenance wiring can be
                exercised end to end.
            </p>
        </nav>
    );
}
